<template>
  <div class="coupon-detail">
    <ul>
      <li>
        <span>优惠券名称：</span>
        <font>{{coupon_detail.coupon}}</font>
      </li>
      <li>
        <span>赠送对象：</span>
        <font>{{coupon_detail.names}}</font>
      </li>
      <li>
        <span>赠送日期：</span>
        <font>{{coupon_detail.created_at}}</font>
      </li>
      <li>
        <span>状态：</span>
        <font>{{coupon_detail.status == 1 ? "正常": "已撤销"}}</font>
      </li>
      <li>
        <span>使用人数/赠送人数：</span>
        <font>{{coupon_detail.used + "/" + coupon_detail.user_num}}张</font>
      </li>
      <li>
        <span>已使用学员：</span>
        <font>{{coupon_detail.usedNames}}</font>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      coupon_detail: {}
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.$http
        .get(`/api/handSel/coupon/${this.$route.query.id}`)
        .then(res => {
          res.created_at = this.$pub.timestampToDay(res.created_at);
          this.coupon_detail = res;
        });
    }
  }
};
</script>

<style lang='scss' scoped>
.coupon-detail {
  padding: 20px 30px;
  ul {
    li {
      display: flex;
      font-size: 16px;
      font-family: "微软雅黑";
      color: #333;
      line-height: 36px;
      span {
        width: 160px;
        text-align: right;
      }
      font {
        margin-left: 10px;
      }
    }
  }
}
</style>
